export default {
  getCountryDataStatus: {
    loading: false,
    error: false,
    data: null,
  },
};
